export default __webpack_public_path__ + "0c75c780a2ce89612a259b5b38cc095d.png";